/*
 * Amazon button -> Meta + TikTok pixel "AddToCart".
 * When an Amazon CTA opts in (data-meta-atc), fire a Meta AddToCart event and
 * a TikTok AddToCart event on click. Each pixel (fbq / ttq) is expected to
 * already be on the page - whichever is not loaded is skipped silently. Bound
 * once via delegation, so multiple buttons / re-rendered sections are all
 * covered.
 */
(function () {
  if (window.__amazonButtonMetaInit) return;
  window.__amazonButtonMetaInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[data-meta-atc]');
      if (!link) return;

      var name = link.getAttribute('data-meta-atc-name');
      var value = link.getAttribute('data-meta-atc-value');
      var currency = link.getAttribute('data-meta-atc-currency');

      if (typeof window.fbq === 'function') {
        var metaPayload = {};
        if (name) metaPayload.content_name = name;
        if (value) metaPayload.value = parseFloat(value);
        if (currency) metaPayload.currency = currency;

        try {
          window.fbq('track', 'AddToCart', metaPayload);
        } catch (e) {
          /* never block the outbound Amazon click */
        }
      }

      if (window.ttq && typeof window.ttq.track === 'function') {
        var tiktokPayload = { content_type: 'product' };
        if (name) tiktokPayload.contents = [{ content_name: name, quantity: 1 }];
        if (value) tiktokPayload.value = parseFloat(value);
        if (currency) tiktokPayload.currency = currency;

        try {
          window.ttq.track('AddToCart', tiktokPayload);
        } catch (e) {
          /* never block the outbound Amazon click */
        }
      }
    },
    // capture: fire before the browser follows the link
    true
  );
})();
